(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-favorites"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.getElementById('FavoritesGrid');
    const emptyState = document.getElementById('FavoritesEmptyState');
    if (!grid || !emptyState || !window.PokeZoneFavorites) return;

    const currency = grid.dataset.currency || 'NOK';
    const formatter = new Intl.NumberFormat('nb-NO', { style: 'currency', currency });

    async function render() {
      const handles = window.PokeZoneFavorites.getFavorites();

      if (handles.length === 0) {
        grid.hidden = true;
        grid.innerHTML = '';
        emptyState.hidden = false;
        return;
      }

      const products = await Promise.all(
        handles.map((handle) =>
          fetch(`/products/${handle}.js`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        )
      );

      grid.innerHTML = '';
      const validProducts = products.filter(Boolean);

      if (validProducts.length === 0) {
        emptyState.hidden = false;
        grid.hidden = true;
        return;
      }

      emptyState.hidden = true;
      grid.hidden = false;

      validProducts.forEach((product) => {
        const link = document.createElement('a');
        link.href = product.url;
        link.className = 'favorites-grid__item';

        const imageUrl = product.featured_image || (product.images && product.images[0]) || '';

        link.innerHTML = `
          <div class="favorites-grid__image-wrapper">
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" width="400" height="400">` : ''}
          </div>
          <p class="favorites-grid__title">${product.title}</p>
          <p class="favorites-grid__price">${formatter.format(product.price / 100)}</p>
        `;

        grid.appendChild(link);
      });
    }

    render();
    document.addEventListener('favorites:updated', render);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="RecentlyViewed-"]').forEach(async (root) => {
      const grid = root.querySelector('[id^="RecentlyViewedGrid-"]');
      if (!grid || !window.PokeZoneRecentlyViewed) return;

      const currentHandle = root.dataset.currentHandle;
      const currency = root.dataset.currency || 'NOK';
      const formatter = new Intl.NumberFormat('nb-NO', { style: 'currency', currency });

      const handles = window.PokeZoneRecentlyViewed.getRecentlyViewed().filter(
        (handle) => handle !== currentHandle
      );

      if (handles.length === 0) return;

      const products = await Promise.all(
        handles.map((handle) =>
          fetch(`/products/${handle}.js`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        )
      );

      const validProducts = products.filter(Boolean);
      if (validProducts.length === 0) return;

      validProducts.forEach((product) => {
        const link = document.createElement('a');
        link.href = product.url;
        link.className = 'recently-viewed-grid__item';

        const imageUrl = product.featured_image || (product.images && product.images[0]) || '';

        link.innerHTML = `
          <div class="recently-viewed-grid__image-wrapper">
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" width="400" height="400">` : ''}
          </div>
          <p class="recently-viewed-grid__title">${product.title}</p>
          <p class="recently-viewed-grid__price">${formatter.format(product.price / 100)}</p>
        `;

        grid.appendChild(link);
      });

      root.hidden = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
